<mat-chip-listbox class="my-2" *ngIf="flagDefs">
  <mat-chip-option color="{{flagDef?.colour}}" *ngFor="let flagDef of flagDefs" removable="false"
    selected>
    {{flagDef.name}}
  </mat-chip-option>
</mat-chip-listbox>
